const AUDIO_EXTENSIONS = ['mp3', 'wav', 'm4a'];
const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mkv'];
export const getMediaType = filename => {
  const fileNameArr = (filename || '').split('.');
  const extension = fileNameArr[fileNameArr.length - 1];

  if (AUDIO_EXTENSIONS.includes(extension)) return 'audio';
  if (VIDEO_EXTENSIONS.includes(extension)) return 'video';
  return null;
};

export const hasAudioTracks = videoNode =>
  (typeof videoNode.mozHasAudio !== 'undefined' && videoNode.mozHasAudio) ||
  (typeof videoNode.webkitAudioDecodedByteCount !== 'undefined' &&
    videoNode.webkitAudioDecodedByteCount > 0);
